import { render, staticRenderFns } from "./ordersEdit.vue?vue&type=template&id=92535fea&scoped=true&"
import script from "./ordersEdit.vue?vue&type=script&lang=js&"
export * from "./ordersEdit.vue?vue&type=script&lang=js&"
import style0 from "./ordersEdit.vue?vue&type=style&index=0&id=92535fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92535fea",
  null
  
)

export default component.exports